export class InvalidKeyPathError extends Error {
  constructor() {
    super('invalid key path')
  }
}
